const isThisDisabled = user => {
  // Uncomment this and comment below to make elections visible only to admins who are verified
  // const disableElections = user.role !== 'ADMIN';

  // Uncomment this and comment above to make elections visible to everybody who is verified
  // const disableElections = false;

  // Elections are now controlled by backend time settings
  // Set to false to show voting links - backend will enforce time windows
  const disableElections = false;

  // Results visible to admins only (or change to true for everyone)
  const showResults = user.role === 'ADMIN' || user.role === 'SUPER_ADMIN';

  // Uncomment this and comment above to make results visible to everybody who is verified
  // const showResults = true;

  const disableElectionsHallAssembly = user.floor === 'OffCampus / ABH BQs';

  return {
    isDisabledElections: disableElections,
    // || !user.verified,
    isDisabledElectionsExecutive: disableElections,
    // || !user.verified,
    isDisabledElectionsHallAssembly:
      disableElections || disableElectionsHallAssembly,
    // || !user.verified,
    isDisabledElectionResults: !showResults,
    // || !user.verified,
  };
};
export default isThisDisabled;

export const disabled = {
  registration: false,
};
